// extracted by mini-css-extract-plugin
export default {"CompanionAppLinks":"CompanionAppLinks_CompanionAppLinks__n3xEB"};